import { render, staticRenderFns } from "./BuildingPricer.vue?vue&type=template&id=296787c9&scoped=true&"
import script from "./BuildingPricer.vue?vue&type=script&lang=js&"
export * from "./BuildingPricer.vue?vue&type=script&lang=js&"
import style0 from "./BuildingPricer.vue?vue&type=style&index=0&id=296787c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296787c9",
  null
  
)

export default component.exports